module.exports = __webpack_public_path__ + "img/cuttingboard.95f71b2b.jpg";